import { render, staticRenderFns } from "./FormulaComponent.vue?vue&type=template&id=2880a91f&scoped=true&"
import script from "./FormulaComponent.vue?vue&type=script&lang=ts&"
export * from "./FormulaComponent.vue?vue&type=script&lang=ts&"
import style0 from "./FormulaComponent.vue?vue&type=style&index=0&id=2880a91f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2880a91f",
  null
  
)

export default component.exports